import useClusterConfig from "hooks/useClusterConfig";
const useSearchConfiguration = () => {
  const { data: config, refetch } = useClusterConfig(
    "org.graylog2.indexer.searches.SearchesClusterConfig"
  );
  return { config, refresh: refetch };
};
export default useSearchConfiguration;
